import React, { useEffect } from 'react';
import { Button, Collapse, Form, Space } from 'tdesign-react';
import CodeMirrorLight from '@/components/CodeMirrorLight';
import Body from '../components/Body';

const { FormItem } = Form;
const { Panel: CollapsePanel } = Collapse;

export default function RestartStep({ preStep, nextStep, cache }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (cache) {
      form.setFieldsValue(cache);
    }
  }, [cache, form]);

  const handleSubmit = ({ validateResult, fields }) => {
    if (validateResult === true) {
      nextStep(fields);
    }
  };

  return (
    <Form form={form} labelWidth={120} onSubmit={handleSubmit}>
      <Body
        footer={
          <Space size='small'>
            <Button variant='outline' onClick={preStep}>
              上一步
            </Button>
            <Button theme='primary' onClick={() => form.submit()}>
              下一步
            </Button>
          </Space>
        }
      >
        <Collapse borderless defaultExpandAll expandIconPlacement='right'>
          <CollapsePanel header='START/RESTART服务脚本'>
            <FormItem className='hide' name={['scriptCreateBOList', 0, 'id']} />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 0, 'launchStageEnum']}
              initialData='RESTART'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 0, 'scriptBusinessEnum']}
              initialData='RESTART'
            />
            <FormItem
              className='hide'
              name={['scriptCreateBOList', 0, 'scriptLevelEnum']}
              initialData='FORM_FILLING'
            />
            <FormItem name={['scriptCreateBOList', 0, 'scriptContent']}>
              <CodeMirrorLight />
            </FormItem>
          </CollapsePanel>
        </Collapse>
      </Body>
    </Form>
  );
}
